export default {"src":"/_next/static/media/peanuts.abdeac38.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};